import axios from "axios"
import { env } from "../constants"

export const ticket = (token, data) => {
    const uri = `${env.startpoint}support/tickets`
    const headers = { headers: { Authorization: `Bearer ${token}` } }
    return axios.post(uri, data, headers).then(response => response).catch(error => error.response)
}

export const faq = () => {
    const uri = `${env.startpoint}faq`
    return axios.get(uri).then(response => response).catch(error => error.response)
}
